import { useIsOrgReadOnly } from '@/components/auth/claimsUtils';
import { Button, Modal, useOpenClose } from '@palmetto/palmetto-components';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { Flag, QueueStatus, QueueType } from 'types';

import { CompleteQueueRevampReviewModal } from './CompleteQueueRevampReviewModal';
import { CompleteQueueReviewModal } from './CompleteQueueReviewModal';

interface CompleteReviewProps {
  disableApproval?: boolean;
  disableAllApprovals?: boolean;
  isForMilestonePackage?: boolean;
  canSubmitReview: boolean;
  handleFormSave: (targetStatus?: QueueStatus) => Promise<void>;
  conditionallyApprovedFlags?: Flag[];
  subQueueInfo?: {
    type: QueueType | undefined;
    status: QueueStatus | undefined;
  };
}

export const CompleteQueueReview = ({
  disableApproval,
  disableAllApprovals,
  isForMilestonePackage = true,
  canSubmitReview,
  handleFormSave,
  conditionallyApprovedFlags,
  subQueueInfo,
}: CompleteReviewProps) => {
  const { flagDrivenPackageReview = false } = useFlags();
  const { isOpen: isModifyOpen, handleClose, handleToggle } = useOpenClose();
  const title = flagDrivenPackageReview ? 'Determine Review Status' : 'Complete Review';
  const allowsAction = useIsOrgReadOnly();

  return (
    <>
      <Modal
        isOpen={isModifyOpen}
        onDismiss={() => {
          handleClose();
        }}
        maxWidth="5xl"
        ariaLabelledBy="completeReviewHeader"
        fullScreenMobile
        overflow="scroll"
      >
        <Modal.Header
          id="completeReviewHeader"
          title={title}
          onDismiss={() => {
            handleClose();
          }}
        />
        {flagDrivenPackageReview ? (
          <CompleteQueueRevampReviewModal
            handleClose={handleClose}
            handleFormSave={handleFormSave}
            disableApproval={disableApproval}
            conditionallyApprovedFlags={conditionallyApprovedFlags}
            subQueueInfo={{ type: subQueueInfo?.type, status: subQueueInfo?.status }}
          />
        ) : (
          <CompleteQueueReviewModal
            handleClose={() => {
              handleClose();
            }}
            disableApproval={disableApproval}
            disableAllApprovals={disableAllApprovals}
            isForMilestonePackage={isForMilestonePackage}
            handleFormSave={handleFormSave}
          />
        )}
      </Modal>
      <Button
        variant="primary"
        size="md"
        style={{ width: 'fit-content' }}
        onClick={handleToggle}
        disabled={!canSubmitReview || !allowsAction}
      >
        Complete Review
      </Button>
    </>
  );
};
